import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol viewBox=\"0 0 21 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-facebook\">\n<path d=\"M8.49219 6.66667H5.99219V10H8.49219V20H12.6589V10H15.6589L15.9922 6.66667H12.6589V5.25C12.6589 4.5 12.8255 4.16667 13.5755 4.16667H15.9922V0H12.8255C9.82552 0 8.49219 1.33333 8.49219 3.83333V6.66667Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol